<template>
  <div class="TipsAndPrivewDilog">
        <img :src="Url" v-b-toggle="id">
        <b-sidebar :visible="false" :id="id" :title='Title' 
         v-b-toggle="'Privew_Page'"
         right bg-variant="white"  :shadow="true" backdrop>
          <div class="tab-pane active">
              <div class="card shadow-none">
                  <div class="card-body">
                      <img :src="Url" width="100%" />

                  </div>
              </div>
          </div>
      </b-sidebar>

  </div>
</template>

<script>
export default {
  props:{
    id:{
      type:String,
      default:""
    },
    Url:{
      type:String,
      default:""
    },
    Title:
    {
      type:String,
      default:""
    }
  },
  data(){
      return {
      }
  },
  watch:{
   
  },
  computed:{
    langid() {
            return localStorage.getItem("currentLangId")
        }
  },
  mounted(){  
    
  },
  methods:{
    scrollToAdPosition() {
            this.$el.children[1].lastElementChild.scrollTo({
                top: 800,
                left: 0,
                behavior: 'smooth'
            });
        }
  }
}
</script>
<style lang="scss" scoped>
</style>